<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'guardian.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container mb-4 pt-lg-4">
  <!-- Display only when it's loaded -->
  <ng-container *ngIf="isLoaded">
    <ng-container *ngIf="isGuardian; else notGuardian">
      <div class="child-list">
        <fgb-child-list></fgb-child-list>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #notGuardian>
    <div class="border border-grey rounded overflow-hidden guardian-info-card">
      <div class="guardian-info-image-container bg-primary"></div>
      <div class="guardian-info-container bg-secondary text-white">
        <h2 class="guardian-info-title">
          {{ 'guardian.page.info.title' | translate }}
        </h2>
        <div
          class="guardian-info-text-wrapper font-size-14"
          [innerHTML]="'guardian.page.info' | translate | markdownTranslate"
        ></div>
        <button
          (click)="confirmRegisterModal(confirmRegister)"
          class="btn btn-primary btn-guardian text-center text-white mt-auto"
        >
          {{ 'guardian.page.registerbutton' | translate: { fgbdefault: 'Register as a Guardian' } }}
        </button>
      </div>
    </div>
  </ng-template>

  <div class="border border-grey rounded overflow-hidden annoucement-info-card mt-20">
    <img src="assets/images/kids/guardian-announcement.jpg" draggable="false" />

    <div class="annoucement-info-container bg-secondary text-white">
      <div
        class="annoucement-info-text-wrapper font-size-14"
        [innerHTML]="'guardians.page.annoucement.info' | translate | markdownTranslate"
      ></div>
    </div>
  </div>

  <div class="row mt-20">
    <div class="col-lg-6 col-12">
      <div class="bg-primary membership-details paid-membership-bg"></div>
      <div class="accordion" id="accordionRight">
        <div class="accordion-item border border-grey">
          <div class="accordion-header" id="headingRight">
            <button
              class="accordion-button collapsed text-white bg-secondary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseRight"
              aria-expanded="true"
              aria-controls="collapseRight"
            >
              {{ 'guardian.page.benefit.include' | translate }}
            </button>
          </div>
          <div
            id="collapseRight"
            class="accordion-collapse collapse"
            aria-labelledby="headingRight"
            data-bs-parent="#accordionRight"
          >
            <div
              class="accordion-body"
              [innerHTML]="'guardian.page.paid.benefit.description' | translate | markdownTranslate"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12 mb-lg-0 mb-4">
      <div class="bg-primary membership-details free-membership-bg"></div>
      <div class="accordion" id="accordionLeft">
        <div class="accordion-item border border-grey">
          <div class="accordion-header" id="headingLeft">
            <button
              class="accordion-button collapsed text-white bg-secondary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseLeft"
              aria-expanded="true"
              aria-controls="collapseLeft"
            >
              {{ 'guardian.page.benefit.include' | translate }}
            </button>
          </div>
          <div
            id="collapseLeft"
            class="accordion-collapse collapse"
            aria-labelledby="headingLeft"
            data-bs-parent="#accordionLeft"
          >
            <div
              class="accordion-body"
              [innerHTML]="'guardian.page.free.benefit.description' | translate | markdownTranslate"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Confirm modal to become a guardian-->
<ng-template #confirmRegister let-modal>
  <div class="register-guardian-modal" ngbAutofocus>
    <div class="register-guaridan-modal-header">
      <div class="font-size-14 fw-bold">
        {{ 'guardian.page.register.guardian.modal.title' | translate: { fgbdefault: 'Guardian' } }}
      </div>
    </div>
    <div class="register-guardian-modal-body">
      <p class="font-size-14">
        {{ 'guardian.page.confirminfo' | translate: { fgbdefault: 'Are you sure you wish to become a Guardian?' } }}
      </p>
    </div>
    <div class="modal-footer d-flex justify-content-end mt-auto w-100 font-size-14">
      <button class="btn text-white fw-bold" (click)="modal.dismiss()">Cancel</button>
      <button class="btn btn-success btn-confirm fw-bold" (click)="becomeGuardian(); modal.dismiss()">Confirm</button>
    </div>
  </div>
</ng-template>
